module.exports = __webpack_public_path__ + "static/c18-412ed09486df07fb574b9887dd932fc2.jpg";